let API_BASE = "/api";

export class UserConstants {
  public static API_USER_ENGINE_SETTINGS =
    API_BASE + "/user/{userId}/engine-settings";

  public static API_USER_SEARCH = API_BASE + "/user/search";
}
